import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import SelectSearch from "../../common/components/SelectSearch";
import { useReportAccidentQuery } from "../reportRoadAccidents/hooks/useReportAccidentQuery";
import { ROUTES } from "../../core/routes/routes";
import Button from "../../common/components/Button";
import { useDisseminationLessonCommand } from "./hooks/useDisseminationLessonCommand";
import FileUploader from "../../common/components/FileUploader";

function RegisterDisseminationLesson() {
  const location = useLocation();
  const navigateTo = useNavigate();
  const editData = location.state?.editData || null;
  const isEditing = !!editData;

  const {
    createDisseminationLesson,
    updateDisseminationLesson,
    disseminationLesson,
    errors,
    handleChangeDisseminationLesson,
    setDisseminationLesson,
  } = useDisseminationLessonCommand(() => {
    if (isEditing) navigateTo(ROUTES.LIST_DISSEMINATION_LESSON);
  });
  const [search, setSearch] = useState(disseminationLesson.accident || "");
  const { reportAccidents } = useReportAccidentQuery({ search, limit: 10, ...(isEditing ? {} : { excludeWithLesson: true }) });

  useEffect(() => {
    if (editData) {
      setDisseminationLesson({
        id: editData.id,
        accident: editData.reportAccident?.id || editData.accident || "",
        lesson: editData.lesson || null,
      });
    }
  }, []);

  const handleChangeFile = (file) => {
    if (file) {
      handleChangeDisseminationLesson({
        name: "lesson",
        value: file,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEditing) {
      updateDisseminationLesson({ ...disseminationLesson, id: editData.id });
    } else {
      createDisseminationLesson(disseminationLesson);
    }
  };

  return (
    <main
      className="container p-3"
    >
      <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
        <section className="border border-dark rounded flex-column">
          <header className="bg-dark p-3 text-white">
            <h2 className="fs-4">Selecciona un siniestro</h2>
          </header>
          <div className="p-3">
            <SelectSearch
              name="accident"
              label="Siniestros"
              placeholder="Selecciona un siniestro"
              options={reportAccidents.map((accident) => ({
                value: accident.id,
                label: `${accident.dateAccident} - ${accident.id} - ${accident.namePersonInvolved} - ${accident.vehiclePlate}`,
              }))}
              value={disseminationLesson.accident}
              onSelect={handleChangeDisseminationLesson}
              onSearch={(text) => setSearch(text)}
              error={errors.errors.accident}
            />
          </div>
        </section>

        <section className="border border-dark rounded flex-column">
          <header className="bg-dark p-3 text-white">
            <h2 className="fs-4">Leccion aprendida</h2>
          </header>
          <div className="p-3">
            <FileUploader
              accept="application/pdf"
              onFileChange={handleChangeFile}
              error={errors.errors.lesson}
              value={disseminationLesson.lesson}
            />
          </div>
        </section>
        <footer className="w-50 mx-auto">
          <Button type="submit">{isEditing ? "Actualizar" : "Guardar"}</Button>
        </footer>
      </form>
    </main>
  );
}

export default RegisterDisseminationLesson;
